module.exports = __webpack_public_path__ + "img/styria-druck-styria.2456b406.svg";